module.exports = __webpack_public_path__ + "img/neurone-snippet.45d55842.gif";